import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range.js";
import { Platform, Linking } from "react-native";
// import * as mime from "react-native-mime-types";
import branch from "../branchlib";
import { t, tc } from "@/localization";
import { roomLabelText } from "@/components/rooms/roomLabels";

export const openLink = async (url) => {
  if (Platform.OS === "web") {
    document.location.href = url;
  } else {
    await Linking.openURL(url);
    // await WebBrowser.openBrowserAsync(url);
  }
  return true;
};

export const phoneThreshold = 665; //900;
export const minDesktopWidth = phoneThreshold;

export const formatEventDate = (utc, timezone) =>
  utc && timezone && moment(utc).tz(timezone).format(t("MMM Do YYYY, h:mm a"));

export const formatEventDateOnly = (utc, timezone) =>
  utc && timezone && moment(utc).tz(timezone).format(t("MMM Do YYYY"));

export const eventTypes = [
  { value: "wedding", label: t("Wedding"), icon: "heart" },
  { value: "funeral", label: t("Funeral"), icon: "flower" },
  { value: "birthday", label: t("Birthday"), icon: "gift" },

  { value: "school", label: t("School"), icon: "school" },
  { value: "sport", label: t("Sport"), icon: "football" },
  {
    value: "other",
    label: tc("event type", "Other"),
    icon: "ellipsis-horizontal",
  },
  // { value: "memorial", label: "Memorial / Celebration of Life" },
  // { value: "engagement", label: "Engagement" },

  // { value: "graduation", label: "Graduation" },
  // { value: "recital", label: "Recital" },
  // { value: "presentation", label: "Presentation" },
  // { value: "seminar", label: "Seminar" },
  // { value: "business", label: "Business" },
  // { value: "performance", label: "Performance" },
];

export const timezones = moment.tz
  .names()
  .map((tz) => ({ name: tz, value: tz }));

// export const getNameFromFile = (fileuri) => {
//   return mime.(fileuri);
// };

// export const getContentTypeFromFile = (fileuri) => {
//   return mime.lookup(fileuri);
// };

export const bytesToSize = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const getTimeLeft = (event_datetime_utc) => {
  const now = moment();
  const then = moment(event_datetime_utc);

  return moment.duration(now.diff(then)).humanize();
};

export const roles = [
  {
    value: "videographer",
    label: t("Audio/video professional"),
  },
  // {
  //   value: "photographer",
  //   label: "Photographer",
  // },
  {
    value: "funeralhome",
    label: t("Funeral home owner or director"),
  },
  {
    value: "eventplanner",
    label: t("Event planner or venue manager"),
  },
  {
    value: "church",
    label: t("Church, pastor, preacher or minister"),
  },
  {
    value: "school",
    label: t("Teacher or school manager"),
  },
  {
    value: "nonprofit",
    label: t("Nonprofit or charity"),
  },
  {
    value: "livestreamer",
    label: t("Live event streamer or producer"),
  },
  {
    value: "other",
    label: tc("role", "Other"),
  },
];

// Titles the server writes in English, in the app's language: every test
// event is "Test Event", and a room is "<event> — Stage 2". Other titles are
// the user's own words.
export const eventTitle = (event) => {
  const title = event?.title;
  if (event?.is_test && title === "Test Event") return t("Test Event");
  const label = event?.room_of && event.room_label;
  if (label && title?.endsWith(` — ${label}`))
    return `${title.slice(0, -label.length)}${roomLabelText(label)}`;
  return title;
};

// A room noun (rooms.js ROOM_NOUNS, lowercased: "room", "stage"…) in the
// user's language, for sentences like "Each {noun} streams with its own key".
export const roomNounText = (noun) => {
  switch (noun) {
    case "room":
      return tc("room noun", "room");
    case "stage":
      return tc("room noun", "stage");
    case "track":
      return tc("room noun", "track");
    case "court":
      return tc("room noun", "court");
    case "field":
      return tc("room noun", "field");
    case "hall":
      return tc("room noun", "hall");
    case "camera":
      return tc("room noun", "camera");
    default:
      return noun;
  }
};

export const filterBranchParams = (params) => {
  const metadata = Object.keys(params)
    .filter(
      (key) =>
        key.indexOf("+") !== 0 &&
        key.indexOf("~") !== 0 &&
        key.indexOf("$") !== 0
    )
    .reduce((obj, key) => {
      obj[key] = params[key];
      return obj;
    }, {});

  return metadata;
};

const branchWebBaseUrl = "https://broadcaster.eventlive.pro";

const parseBranchUrl = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  try {
    if (value.startsWith("/")) {
      return new URL(value, branchWebBaseUrl);
    }

    if (value.startsWith("eventlive://")) {
      const normalizedValue = value.replace(
        "eventlive://",
        `${branchWebBaseUrl}/`
      );
      return new URL(normalizedValue);
    }

    if (!value.includes("://")) {
      return new URL(`/${value.replace(/^\/+/, "")}`, branchWebBaseUrl);
    }

    return new URL(value);
  } catch (error) {
    return null;
  }
};

const getPathWithQuery = (urlObj) =>
  urlObj ? `${urlObj.pathname}${urlObj.search || ""}` : null;

const toNavigationUrl = (pathWithQuery) => {
  if (!pathWithQuery) {
    return null;
  }

  const normalizedPath = pathWithQuery.startsWith("/")
    ? pathWithQuery
    : `/${pathWithQuery}`;

  if (Platform.OS === "web") {
    return `${branchWebBaseUrl}${normalizedPath}`;
  }

  return `eventlive://${normalizedPath.replace(/^\//, "")}`;
};

const addMetadataToPath = (pathWithQuery, metadata) => {
  const urlObj = parseBranchUrl(pathWithQuery);
  if (!urlObj) {
    return pathWithQuery;
  }

  Object.entries(metadata || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || typeof value === "object") {
      return;
    }

    if (!urlObj.searchParams.has(key)) {
      urlObj.searchParams.set(key, `${value}`);
    }
  });

  return getPathWithQuery(urlObj);
};

const getStreamKeyFromUrl = (urlObj) => {
  if (!urlObj) {
    return null;
  }

  const queryStreamKey =
    urlObj.searchParams.get("streamKey") ||
    urlObj.searchParams.get("stream_key");
  if (queryStreamKey) {
    return queryStreamKey;
  }

  const pathSegments = urlObj.pathname.split("/").filter(Boolean);
  if (
    pathSegments.length >= 2 &&
    pathSegments[0].toLowerCase() === "stream" &&
    pathSegments[1]
  ) {
    return decodeURIComponent(pathSegments[1]);
  }

  return null;
};

const getStreamKeyFromBranchParams = (params) => {
  if (params?.streamKey || params?.stream_key) {
    return params.streamKey || params.stream_key;
  }

  const urlCandidates = [
    params?.$canonical_url,
    params?.$deeplink_path,
    params?.["~referring_link"],
    params?.["+url"],
    params?.["+non_branch_link"],
  ];

  for (const candidate of urlCandidates) {
    const streamKey = getStreamKeyFromUrl(parseBranchUrl(candidate));
    if (streamKey) {
      return streamKey;
    }
  }

  return null;
};

export const getUrlFromBranch = (params) => {
  console.warn(
    "getUrlFromBranch called with params:",
    JSON.stringify(params, null, 2)
  );

  if (!params) {
    console.warn("getUrlFromBranch: No params provided");
    return null;
  }

  const metadata = filterBranchParams(params);

  // Handle stream invites reliably across canonical URL and Branch metadata.
  const streamKey = getStreamKeyFromBranchParams(params);
  if (streamKey) {
    const streamUrl = toNavigationUrl(
      `/stream/${encodeURIComponent(streamKey)}`
    );
    console.warn("getUrlFromBranch: Stream invite URL:", streamUrl);
    return streamUrl;
  }

  if (params.$canonical_url) {
    const canonicalPath = getPathWithQuery(
      parseBranchUrl(params.$canonical_url)
    );
    const routePath = addMetadataToPath(canonicalPath, metadata);
    const routeUrl = toNavigationUrl(routePath);
    console.warn("getUrlFromBranch: URL from canonical path:", routeUrl);
    return routeUrl;
  }

  if (params.$deeplink_path) {
    const deeplinkPath = getPathWithQuery(
      parseBranchUrl(params.$deeplink_path)
    );
    const routePath = addMetadataToPath(deeplinkPath, metadata);
    const routeUrl = toNavigationUrl(routePath);
    console.warn("getUrlFromBranch: URL from deeplink path:", routeUrl);
    return routeUrl;
  }

  if (params["+non_branch_link"]) {
    console.warn(
      "getUrlFromBranch: using non-branch link fallback",
      params["+non_branch_link"]
    );
    return params["+non_branch_link"];
  }

  console.warn("getUrlFromBranch: Could not derive navigation URL");
  return null;
};

// An event link from its title: accents dropped ("Quinceañera de María" →
// "quinceanera-de-maria"), anything else that isn't a letter or digit a dash.
export const makeSlug = (text) => {
  const plain =
    typeof text.normalize === "function"
      ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      : text;
  let slug = plain
    .replace(/\W+/g, "-")
    .toLowerCase()
    .replace(/^-+/, "")
    .replace(/\-+$/gm, "");
  if (slug === "") {
    slug = "event" + Math.floor(100000 + Math.random() * 900000);
  }
  return slug;
};

const getCookie = function (name) {
  var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
  else return "";
};

// Google Ads click id: prefer the URL/branch param, fall back to the _gcl_aw
// cookie gtag sets on .eventlive.pro (format GCL.<timestamp>.<gclid>), which
// survives the redirect from the marketing site to this subdomain.
const collectGclid = (branchdata, metadata) => {
  const passed = branchdata?.gclid || metadata.gclid;
  if (passed) return passed;
  if (Platform.OS !== "web") return "";
  const gclcookie = getCookie("_gcl_aw");
  return gclcookie ? gclcookie.split(".").slice(2).join(".") : "";
};

// Microsoft Ads click id: URL/branch param (auto-tagging appends msclkid),
// falling back to the _uetmsclkid cookie the UET tag sets on .eventlive.pro.
const collectMsclkid = (branchdata, metadata) => {
  const passed = branchdata?.msclkid || metadata.msclkid;
  if (passed) return passed;
  if (Platform.OS !== "web") return "";
  return getCookie("_uetmsclkid").replace(/^_uet/, "");
};

export const collectMetadataFromBranchOrURL = async (branchdata) => {
  try {
    let metadata;
    // Parse web or branch links for UTM, referrals, or params to pass for Joy integration
    if (Platform.OS === "web") {
      const utmParamQueryString = new URLSearchParams(window.location.search);
      metadata = Object.fromEntries(utmParamQueryString);
    } else {
      const params = await branch.getLatestReferringParams();
      metadata = filterBranchParams(params);
    }

    const gapassed = branchdata?._ga || metadata._ga;
    const fbppassed = branchdata?._fbp || metadata._fbp;
    if (fbppassed) {
      metadata.fbp = fbppassed;
      metadata.fbc = branchdata?._fbc || metadata._fbc;
    }
    if (gapassed) {
      const ga = gapassed.split("-").pop();
      metadata.ga = ga;

      // Alternative with _gl:
      // const split = branchdata?._gl.split("*");
      // const encoded = split[split.indexOf("_ga")+1];
      // console.log(atob(encoded.replace(/\.$/, "")));
      //
    } else {
      if (Platform.OS === "web") {
        const gacookie = getCookie("_ga")
          .replace("GA1.2.", "")
          .replace("GA1.1.", "");
        // GA1.2.670622894.1651695890

        console.log("getting ga cookie", gacookie);

        const fbp = getCookie("_fbp");
        const fbc = getCookie("_fbc");

        metadata.ga = gacookie;
        metadata.fbp = fbp;
        metadata.fbc = fbc;
      }
    }

    const gclid = collectGclid(branchdata, metadata);
    if (gclid) {
      metadata.gclid = gclid;
    } else {
      delete metadata.gclid;
    }

    const msclkid = collectMsclkid(branchdata, metadata);
    if (msclkid) {
      metadata.msclkid = msclkid;
    } else {
      delete metadata.msclkid;
    }

    metadata.registered_from = Platform.OS;
    metadata.timezone = moment.tz.guess();

    return metadata;
  } catch (err) {
    console.error(err);
  }
};

export const eventLivePageBase = `https://evt.live/`; //`https://live.eventlive.pro/`; //

export const makeUrl = (event, custom_domain = false) => {
  const domain = custom_domain || eventLivePageBase;
  return event.alias
    ? `${domain}${event.alias}`
    : `${domain}${event.broadcaster}/${event.slug}`;
};

export const makeDownloadUrl = (event, custom_domain = false) => {
  const domain = custom_domain || eventLivePageBase;
  return event.alias
    ? `${domain}${event.alias}/download`
    : `${domain}${event.broadcaster}/${event.slug}/download`;
};

export const formatPriceWithCurrency = (price, currency) => {
  const normalizeNumericPrice = (value) => {
    if (typeof value === "number") {
      return Number.isFinite(value) ? value : NaN;
    }

    if (typeof value !== "string") {
      return NaN;
    }

    let normalized = value.replace(/[^\d,.-]/g, "");
    if (!normalized) {
      return NaN;
    }

    const hasComma = normalized.includes(",");
    const hasDot = normalized.includes(".");

    if (hasComma && hasDot) {
      if (normalized.lastIndexOf(",") > normalized.lastIndexOf(".")) {
        normalized = normalized.replace(/\./g, "").replace(/,/g, ".");
      } else {
        normalized = normalized.replace(/,/g, "");
      }
    } else if (hasComma) {
      normalized = normalized.replace(/,/g, ".");
    }

    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : NaN;
  };

  const numericPrice = normalizeNumericPrice(price);
  if (!Number.isFinite(numericPrice)) {
    return String(price ?? "");
  }

  const roundedPrice = Math.round((numericPrice + Number.EPSILON) * 100) / 100;
  const isWholeAmount = Number.isInteger(roundedPrice);
  let userLocale = navigator.language || "en-US";
  let formatter = new Intl.NumberFormat(userLocale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: isWholeAmount ? 0 : 2, // Hide .00 for whole amounts.
    maximumFractionDigits: isWholeAmount ? 0 : 2,
  });
  return formatter.format(roundedPrice);
};
